import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {catchError, firstValueFrom, of, tap} from "rxjs";

export interface Properties {
  readonly elasticsearchUrl: string;
  readonly dataPortalUrl: string;
  readonly requestHandlerUrl: string;
  readonly requestHandlerNewUrl: string;
  readonly version: string;
}

const properties: Properties = {
  elasticsearchUrl: 'https://2023apr.asa-test.hq.eso.org/aq/service/api/search',
  dataPortalUrl: 'https://2023apr.asa-test.hq.eso.org/dataPortal',
  requestHandlerUrl: 'https://2023apr.asa-test.hq.eso.org/rh',
  requestHandlerNewUrl: 'https://2023apr.asa-test.hq.eso.org/rh-new',
  version: '1.0.0-dev'
}

@Injectable({
  providedIn: 'root'
})
export class AsaxPropertiesService {
  private properties: Properties;

  constructor(private readonly http: HttpClient) {
  }

  getProperties(): Properties {
    return this.properties;
  }

  init(): Promise<Properties> {
    return firstValueFrom(
      this.http.get<Properties>('service/api/v1/properties').pipe(
        tap(properties => this.properties = properties),
        catchError(() => {
          this.properties = properties;
          return of(properties);
        })
      ));
  }
}
